<template>
    <div class="flex flex-1 flex-col h-full max-h-full overflow-y-auto p-8">
        <div class="flex justify-between mb-5 border-b border-gray-300 pb-2">
            <div class="flex items-center">
                <h1 class="page-header">Reports</h1>
                <div class="ml-3 flex items-center text-gray-600">
                    <div class="text-2xl">/</div>
                    <div class="ml-2 pt-1 text-xl">{{ this.reports.filtered.length }} of {{ this.reports.all.length }}</div>
                </div>
            </div>
            <div class="flex items-center">
                <filters
                    data-type="reports"
                    sort-by="category_name"
                    :filters="filters"
                    :show-client-filter="false"
                    :show-view-options="false"
                    v-on:view-change="view = $event">
                        <template slot="filters">
                            <div class="flex items-center mb-4">
                                <span class="mr-6">Category</span>
                                <select v-model="selectedCategory" class="form-select">
                                    <option value=''>All</option>
                                    <option v-for="category in availableCategories" :key="category.id" :value="category.id">{{ category.name }}</option>
                                </select>
                            </div>
                        </template>
                </filters>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl">
            <div class="card w-full" v-for='(report, reportIndex) in this.reports.filtered' :key="reportIndex">
                <a v-bind:href="report.prep_url">
                    <div class="box box-full h-full flex box-indigo">
                        <div class="flex flex-col">
                            <div class="relative flex-1 overflow-hidden">
                                <img class="w-full rounded-t-lg no-scale" :src="report.preview_image">
                            </div>
                            <div class="p-4 leading-loose">
                                <p class="text-xl text-center font-semibold" :title="report.name">{{ report.name }}</p>
                                <p class="leading-6">{{ report.description }}</p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div v-if="! reports.filtered.length">
            <p class="none-found">No Reports Found</p>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'ReoptReports',

        props: {
            reportData: {
                type: [Array, Object],
                required: false
            },

            sortBy: {
                type: String,
                required: false
            },

            sortAsc: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                selectedCategory: '',
                selectedReport: '',
            }
        },

        created() {
            this.$store.dispatch('loadReports');
        },

        mounted() {
            this.reports.all = this.reportData;
            this.reports.filtered = this.reportData;            
        },

        watch: {
            selectedCategory(categoryID) {
                this.selectCategory(categoryID);
                this.availableCategories[categoryID].visible = true;

                this.$emit('filterRequest');
            },
        },

        computed: {
            ...mapState(['reports']),

            all() {
                return this.reports.all;
            },

            filtered() {
                return this.reports.filtered;
            },

            filters() {
                return {
                    category_id: this.selectedCategory,
                    report_id: this.selectedReport,
                }
            },

            availableCategories() {
                return _.each(_.keyBy(this.reports.categories, 'id'), (category) => {
                    category.visible = false;
                });
            },

            availableReports() {
                if (this.selectedCategory == '') {
                    return '';
                }

                return _.filter(this.reports, (report) => {
                    return report.category_id == this.selectedCategory
                })
            }
        },
    }
</script>